<script>
import baseList from "@/views/components/base/baseList.vue";
import { Tag, Button } from "view-design";
import Vue from "vue";
import Info from "../info.vue";
import Repair from "../repair.vue";
import Track from "../track.vue";
import Evaluatte from "../evaluate.vue";
import ExpenseAccount from "../expenseAccount.vue";
import EditPro from "../editProcessing.vue";
import timeIcon from "../../../assets/img/timeIcon.png";

export default {
  extends: baseList,
  components: {
    info: Info,
    Repair,
    Track,
    Evaluatte,
    ExpenseAccount,
    EditPro,
  },
  data() {
    return {
      makeMain: "",
      menu_name: "",
      table: {
        mname: "work",
        key: "id",
        url: {
          del: "/admin/system/work/del",
        },
      },
      actions: [
        {
          label: "导出工单",
          icon: "md-download",
          type: "info",
          onClick: this.exportData.bind(this, "资产列表", 3),
          auth: "admin/completed/exportData",
        },
      ],
      menus: [
        {
          label: "待处理",
          name: "workOrder_list",
          auth: "system/workOrder/index",
          badge: {
            mname: "workstate",
            scene: "1",
            url: "/admin/system/work/state",
          },
        },
        {
          label: "处理中",
          name: "processing_list",
          auth: "system/processing/index",
          badge: {
            mname: "workstate",
            scene: "2",
            url: "/admin/system/work/state",
          },
        },
        {
          label: "挂起中",
          name: "workPending_list",
        },
        {
          label: "已完成",
          name: "completed_list",
          auth: "system/completed/index",
          // badge: { mname: "workstate", scene: "3" },
        },
        {
          label: "抢单池",
          name: "workOrder_seize",
          badge: {
            mname: "workstate",
            scene: "4",
            url: "/admin/system/work/state",
          },
        },
        {
          label: "回收站",
          name: "workOrder_recyle",
        },
      ],
      query: {
        state: 3,
      },
      filters: [
        {
          label: "故障原因",
          KeyEnter: this.search,
          name: "teackRemark",
          value: "",
          type: "input",
        },
        {
          label: "报修时间",
          KeyEnter: this.search,
          name: "repairTime",
          value: "",
          type: "datetimerange",
        },
        {
          label: "工单类型",
          name: "typeId",
          value: "",
          KeyEnter: this.search,
          type: "select",
          dropList: [],
        },
        {
          label: "报修人电话",
          name: "repairPhone",
          value: "",
          KeyEnter: this.search,
          type: "input",
        },
        {
          label: "报修人",
          KeyEnter: this.search,
          name: "repairBy",
          value: "",
          type: "input",
        },
        // {
        //   label: "资产",
        //   name: "facilityNo",
        //   value: "",
        //   KeyEnter: this.search,
        //   type: "select",
        //   dropList: [],
        // },
        {
          label: "资产名称",
          name: "facilityName",
          value: "",
          KeyEnter: this.search,
          type: "input",
        },
        {
          label: "问题描述",
          KeyEnter: this.search,
          name: "descr",
          value: "",
          type: "input",
        },
        // {
        //   label: "科室",
        //   name: "deskId",
        //   value: "",
        //   type: "selectsearch",
        //   dropList: [],
        //   KeyEnter: this.search,
        //   remoteMethod: this.deskChange,
        // },
        {
          label: "科室",
          name: "department",
          value: "",
          type: "input",
          KeyEnter: this.search,
        },
        {
          label: "资产编号",
          KeyEnter: this.search,
          name: "assetNum",
          value: "",
          type: "input",
        },
        {
          label: "处理人",
          KeyEnter: this.search,
          name: "maintainerName",
          value: "",
          type: "input",
        },
        {
          label: "费用汇总",
          name: "expensesSum",
          value: "",
          type: "input",
        },
        {
          label: "报修方式",
          name: "repairType",
          value: "",
          KeyEnter: this.search,
          type: "select",
          dropList: [
            {
              value: 1,
              name: "电话报修",
            },
            {
              value: 2,
              name: "扫码报修",
            },
            {
              value: 3,
              name: "移动报修",
            },
            {
              value: 4,
              name: "后台设备报修",
            },
            {
              value: 5,
              name: "后台科室报修",
            },
            {
              value: 6,
              name: "维修员",
            },
            {
              value: 7,
              name: "用户PC普通",
            },
            {
              value: 8,
              name: "用户PC快速",
            },
          ],
        },
        {
          label: "产生费用",
          name: "expensesIncurred",
          value: "",
          KeyEnter: this.search,
          type: "select",
          dropList: [
            {
              value: 1,
              name: "是",
            },
            {
              value: 2,
              name: "否",
            },
          ],
        },

        // { label: '资产名称', name: 'facilityName', value: '', type: 'input' },
      ],
      tableCols: [
        /* {
          type: "selection",
          width: 60,
        }, */
        {
          title: "序号",
          type: "index",
          width: 80,
          align: "center",
        },
        {
          title: "报修时间",
          width: 180,
          align: "center",
          key: "repairTime",
          sortable: true,
          render: (h, params) => {
            const row = params.row;
            const text = row.repairTime.slice(0, 16);
            return <span>{text}</span>;
          },
        },
        {
          title: "问题描述/处理记录",
          key: "descr",
          minWidth: 500,
          align: "left",
          render: (h, params) => {
            const row = params.row;
            const text = row.descr;
            const processList = row.maintainerContents || [];
            const isOverTime = this.workOrderTime(text, 1) > 30;

            // 生成处理内容列表
            const processContentNodes =
              processList.length > 0
                ? processList.map((item, index) => {
                    const content =
                      typeof item === "string"
                        ? item
                        : item.content || item.remark || item.text || "";
                    const time =
                      typeof item === "object"
                        ? item.time || item.createTime || item.date || ""
                        : "";
                    return h(
                      "div",
                      {
                        style: `display: flex;
    align-items: flex-start;
    padding: 8px 0;
    ${
      index !== processList.length - 1
        ? "border-bottom: 1px dashed #d9d9d9;"
        : ""
    }`,
                      },
                      [
                        // 序号
                        h(
                          "div",
                          {
                            style: `flex-shrink: 0;
    width: 20px;
    height: 20px;
    line-height: 20px;
    text-align: center;
    background: #1890ff;
    color: #fff;
    border-radius: 50%;
    font-size: 12px;
    margin-right: 10px;
    margin-top: 2px;`,
                          },
                          index + 1
                        ),
                        // 内容区
                        h(
                          "div",
                          {
                            style: `flex: 1;`,
                          },
                          [
                            // 时间
                            time
                              ? h(
                                  "div",
                                  {
                                    style: `font-size: 12px;
    color: #8c8c8c;
    margin-bottom: 4px;`,
                                  },
                                  time
                                )
                              : null,
                            // 内容
                            h(
                              "div",
                              {
                                style: `font-size: 13px;
    color: #595959;
    line-height: 1.5;
    word-break: break-all;`,
                                domProps: { title: content },
                              },
                              content
                            ),
                          ]
                        ),
                      ]
                    );
                  })
                : null;

            return h(
              "div",
              {
                style: `display: flex;
  flex-direction: column;
  gap: 10px;
  padding: 10px 0;`,
              },
              [
                // 问题描述区域
                h(
                  "div",
                  {
                    style: `display: flex;
  align-items: flex-start;`,
                  },
                  [
                    // 时间标签
                    h(
                      "div",
                      {
                        style: `padding: 5px 12px;
    border-radius: 4px;
    margin-right: 12px;
    display: flex;
    align-items: center;
    flex-shrink: 0;
    background: ${
      isOverTime
        ? "linear-gradient(135deg, #ff7875 0%, #ff4d4f 100%)"
        : "linear-gradient(135deg, #95de64 0%, #73d13d 100%)"
    };
    box-shadow: 0 2px 4px rgba(0,0,0,0.15);`,
                      },
                      [
                        h("img", {
                          style: `width: 16px;
    height: 16px;
    margin-right: 6px;
    filter: brightness(0) invert(1);`,
                          attrs: { src: timeIcon },
                        }),
                        h(
                          "span",
                          {
                            style: `font-size: 12px;
    font-weight: 600;
    color: #ffffff;
    text-shadow: 0 1px 2px rgba(0,0,0,0.2);`,
                          },
                          this.workOrderTime(text, 2)
                        ),
                      ]
                    ),
                    // 问题描述内容
                    h(
                      "div",
                      {
                        style: `flex: 1;
    line-height: 1.6;
    color: #262626;
    font-size: 14px;
    word-break: break-all;
    padding-top: 2px;`,
                        domProps: {
                          title: this.workOrderTime(text, 3),
                        },
                      },
                      this.workOrderTime(text, 3)
                    ),
                  ]
                ),
                // 处理内容区域
                processList.length > 0
                  ? h(
                      "div",
                      {
                        style: `background: linear-gradient(135deg, #e6f7ff 0%, #f0f5ff 100%);
    border: 1px solid #91d5ff;
    border-radius: 8px;
    overflow: hidden;`,
                      },
                      [
                        // 标题栏
                        h(
                          "div",
                          {
                            style: `display: flex;
    align-items: center;
    padding: 8px 12px;
    background: linear-gradient(90deg, #1890ff 0%, #096dd9 100%);
    color: #fff;
    font-size: 13px;
    font-weight: 500;`,
                          },
                          [
                            h(
                              "span",
                              { style: "margin-right: 8px;" },
                              "处理记录"
                            ),
                            h(
                              "span",
                              {
                                style: `padding: 1px 6px;
    background: rgba(255,255,255,0.2);
    border-radius: 10px;
    font-size: 11px;`,
                              },
                              `${processList.length}条`
                            ),
                          ]
                        ),
                        // 列表内容
                        h(
                          "div",
                          {
                            style: `padding: 4px 12px;`,
                          },
                          processContentNodes
                        ),
                      ]
                    )
                  : null,
              ]
            );
            // let tempDescr;
            // if (text != null) {
            //   let arr = text.split("]");
            //   let tempDate = parseInt(arr[0]);
            //   if (tempDate < 60) {
            //     if (arr[1] !== "null"){
            //       tempDescr = "[" + "0时" + tempDate + "分]" + arr[1];
            //     }else{
            //       tempDescr = "[" + "0时" + tempDate + "分]"
            //     }
            //   } else if (tempDate > 60 || tempDate === 60) {
            //     let hour = Math.floor(tempDate / 60);
            //     let min = tempDate % 60;
            //     if (arr[1] !== "null"){
            //       tempDescr = "[" + hour + "时" + min + "分]" + arr[1];
            //     }else{
            //       tempDescr = "[" + hour + "时" + min + "分]"
            //     }
            //   }
            // }
            // return h("div", [
            //   h(
            //     "span",
            //     {
            //       style: {
            //         display: "inline-block",
            //         width: "100%",
            //         overflow: "hidden",
            //         textOverflow: "ellipsis",
            //         whiteSpace: "nowrap",
            //       },
            //       domProps: {
            //         title: tempDescr,
            //       },
            //     },
            //     tempDescr
            //   ),
            // ]);
          },
        },
        /*   {
            title: "工单类型",
            key: "typeName",
            minWidth: 120,
            align: "left",
            tooltip: "true",
          }, */
        {
          title: "所在科室",
          key: "department",
          minWidth: 120,
          align: "left",
          tooltip: "true",
        },
        {
          title: "报修人",
          width: 120,
          align: "center",
          key: "repairBy",
          // sortable: true,
          tooltip: "true",
        },
        /*  {
           title: "具体位置",
           key: "address",
           minWidth: 100,
           align: "left",
           tooltip: "true",
         },
         {
           title: "报修人",
           minWidth: 100,
           align: "left",
           key: "repairBy",
           sortable: true,
           tooltip: "true",
         },
         {
           title: "报修电话",
           key: "repairPhone",
           minWidth: 130,
           align: "left",
           copy: true,
         },
 
         {
           title: "协同工单",
           key: "isSynergy",
           minWidth: 100,
           align: "center",
           render: (h, params) => {
             const row = params.row;
             const text = row.isSynergy === 0 ? "否" : "是";
             return <span style={{ "font-size": "14px" }}>{text}</span>;
           },
         },
 
         {
           title: "费用",
           key: "expensesIncurred",
           minWidth: 100,
           align: "left",
         },
         {
           title: "状态",
           key: "state",
           minWidth: 100,
           align: "center",
           render: (h, params) => {
             const row = params.row;
             const text = row.state === 3 ? "已完成" : "";
             return <span style={{ "font-size": "14px" }}>{text}</span>;
           },
         },
        {
          title: "报修来源",
          key: "repairSource",
          width: 140,
          align: "center",
          render: (h, params) => {
            const row = params.row;
            const text =
              row.repairSource === 1 && row.isFastOrder === 0
                ? "扫码报修"
                : row.repairSource === 1 && row.isFastOrder === 1
                ? "移动报修"
                : row.repairSource === 4
                ? row.repairPhone
                  ? row.repairPhone
                  : "电话报修"
                : row.repairSource === 5 && row.isFastOrder === 0
                ? "用户PC普通"
                : row.repairSource === 5 && row.isFastOrder === 1
                ? "用户PC快速"
                : row.repairSource === 3 && row.isFastOrder === 0
                ? "后台设备报修"
                : row.repairSource === 3 && row.isFastOrder === 1
                ? "后台科室报修"
                : row.repairSource === 2
                ? "维修员"
                : "";
            return <span style={{ "font-size": "14px" }}>{text}</span>;
          },
        }, */
        {
          title: "处理人",
          key: "maintainerName",
          width: 120,
          align: "center",
        },
        {
          title: "操作",
          align: "center",
          width: 290,
          key: "handle",
          fixed: "right",
          handle: [
            /* (vm, h, currentRow, param) => {
              // let directives = []
              let directives = [{ name: "auth", value: "system/processing/repair" }];
              return (
                <Button
                  {...{ directives }}
                  size="small"
                  onClick={() => this.toEdit(currentRow)}
                  type="default"
                  style={{
                    border: "none",
                    color: "#4991ff",
                    marginRight: "5px",
                  }}
                >
                  写记录
                </Button>
              );
            }, */
            (vm, h, currentRow, param) => {
              // let directives = []
              let directives = [
                { name: "auth", value: "admin/completed/info" },
              ];
              return (
                <Button
                  {...{ directives }}
                  size="small"
                  onClick={() => this.toInfo(currentRow)}
                  type="default"
                  style={{
                    border: "none",
                    color: "#4991ff",
                    marginRight: "5px",
                  }}
                >
                  详情
                </Button>
              );
            },
            (vm, h, currentRow, param) => {
              // let directives = []
              let directives = [
                { name: "auth", value: "admin/completed/evaluate" },
              ];
              return (
                <Button
                  {...{ directives }}
                  size="small"
                  onClick={() => this.toEvaluate(currentRow)}
                  type="default"
                  style={{
                    border: "none",
                    color: "#4991ff",
                    marginRight: "5px",
                  }}
                >
                  评价
                </Button>
              );
            },
            (vm, h, currentRow, param) => {
              let directives = [
                { name: "auth", value: "admin/completed/expenseAccount" },
              ];
              return (
                <Button
                  {...{ directives }}
                  size="small"
                  onClick={() => this.toPrint(currentRow)}
                  type="default"
                  style={{
                    border: "none",
                    color: "#4991ff",
                  }}
                >
                  打印
                </Button>
              );
            },
            "del",
          ],
        },
      ],
    };
  },
  created() {
    let query = this.$route.query;
    if (query.facilityNo) {
      this.query.facilityNo = query.facilityNo;
    }
    // this.loadLevelData();
    this.loadLevelDatas();
    this.loaddeskData();
  },
  methods: {
    workOrderTime(e, type) {
      if (type == 1) {
        let timeA = Number(e.split("]")[0]);
        return timeA;
      } else if (type == 2) {
        let timeB = Number(e.split("]")[0]);
        let returnTime = "";
        if (timeB >= 60 * 24) {
          let d = parseInt(timeB / (60 * 24));
          let h = parseInt((timeB % (60 * 24)) / 60);
          let m = (timeB % (60 * 24)) % 60;
          returnTime = `${d}天${h}时${m}分`;
        } else if (60 * 24 >= timeB && timeB >= 60) {
          let ha = parseInt(timeB / 60);
          let ma = timeB % 60;
          returnTime = `${ha}时${ma}分`;
        } else {
          returnTime = `${timeB}分`;
        }
        return returnTime;
      } else if (type == 3) {
        let timeC = e.split("]")[1];
        return timeC;
      }
    },
    deskChange(query) {
      if (query !== "") {
        setTimeout(async () => {
          let q = {
            deskName: query,
          };

          $utils.api
            .load(`/admin/system/desk/selectList`, q, "get")
            .then((res) => {
              const list = res.rows.map((item) => {
                return {
                  value: item.id,
                  name: item.deskName,
                };
              });
              // let dropList = list.filter(item => item.label.toLowerCase().indexOf(query.toLowerCase()) > -1);

              for (let index = 0; index < this.filters.length; index++) {
                const element = this.filters[index];
                if (element && element.name == "deskId") {
                  this.filters[index]["dropList"] = list;
                }
              }
            });
        }, 200);
      } else {
        this.dropList = [];
      }
    },
    /* toEdit(row) {
      this.$Modal.success({
        closable: true,
        title: "填写记录",
        width: "1000px",
        okText: "取消",
        showOk: false,
        render: (h) => {
          return (
            <EditPro
              style={{ margin: "0", color: "#19be6b" }}
              workId={row.id}
              typeId={row.typeId}
              state={row.state}
            ></EditPro>
          );
        },
      });
    }, */
    loaddeskData() {
      // 通过pk查询字典数据
      let q = {};
      // q.state = 2;
      $utils.api
        .load(`/admin/system/desk/selectList/?isParent=${"0"}`, q)
        .then((res) => {
          if (res && res.rows) {
            let ll = res.rows;
            let dropList = [];
            for (let index = 0; index < ll.length; index++) {
              const element = ll[index];
              let xx = {};
              xx.value = element.id;
              xx.name = element.deskName;
              xx.children = element.children || [];
              dropList.push(xx);
            }
            for (let index = 0; index < this.filters.length; index++) {
              const element = this.filters[index];
              if (element && element.name == "deskId") {
                this.filters[index]["dropList"] = (
                  element["dropList"] || []
                ).concat(dropList);
              }
            }
          }
        });
    },
    loadLevelDatas() {
      // 通过pk查询字典数据
      let q = {};
      // q.state=1
      $utils.api.load("/admin/system/workType/selectList", q).then((res) => {
        if (res && res.rows) {
          let ll = res.rows;
          let dropList = [];
          for (let index = 0; index < ll.length; index++) {
            const element = ll[index];
            let xx = {};
            xx.value = element.id;
            xx.name = element.name;
            xx.children = element.children || [];
            dropList.push(xx);
          }
          for (let index = 0; index < this.filters.length; index++) {
            const element = this.filters[index];
            if (element && element.name == "typeId") {
              this.filters[index]["dropList"] = (
                element["dropList"] || []
              ).concat(dropList);
            }
          }
        }
      });
    },
    loadLevelData() {
      // 通过pk查询字典数据
      let q = {};
      // q.state=1
      $utils.api.load("/admin/system/facility/selectList", q).then((res) => {
        if (res && res.rows) {
          let ll = res.rows;
          let dropList = [];
          for (let index = 0; index < ll.length; index++) {
            const element = ll[index];
            let xx = {};
            xx.value = element.facilityNum;
            xx.name = element.facilityName;
            xx.children = element.children || [];
            dropList.push(xx);
          }
          for (let index = 0; index < this.filters.length; index++) {
            const element = this.filters[index];
            if (element && element.name == "facilityNo") {
              this.filters[index]["dropList"] = (
                element["dropList"] || []
              ).concat(dropList);
            }
          }
        }
      });
    },
    toRepair(row) {
      this.$Modal.success({
        closable: true,
        title: "送修记录",
        width: "1000px",
        okText: "取消",
        showOk: false,
        render: (h) => {
          return (
            <Repair
              style={{ margin: "0", color: "#19be6b" }}
              workId={row.id}
            ></Repair>
          );
        },
      });
    },
    toTrack(row) {
      this.$Modal.success({
        closable: true,
        title: "维修记录",
        width: "1000px",
        okText: "取消",
        showOk: false,
        render: (h) => {
          return (
            <Track
              style={{ margin: "0", color: "#19be6b" }}
              workId={row.id}
            ></Track>
          );
        },
      });
    },
    toInfo(row) {
      $utils.url.push({
        name: "workOrder_info",
        query: { action: "edit", kv: row.id },
      });
    },
    toDel(currentRow) {},
    toImport() {},
    toDownload() {},
    toEvaluate(row) {
      this.$Modal.success({
        closable: true,
        title: "评价",
        width: "1000px",
        height: "80px",
        okText: "取消",
        showOk: false,
        render: (h) => {
          return (
            <Evaluatte
              style={{ margin: "0", color: "#19be6b" }}
              workId={row.id}
            ></Evaluatte>
          );
        },
      });
    },
    toRecycle() {
      $utils.url.push({
        name: "workOrder_recyle",
      });
    },
    toPrint(row) {
      this.$Modal.success({
        closable: true,
        title: "打印",
        width: "1000px",
        height: "80px",
        okText: "取消",
        showOk: false,
        render: (h) => {
          return (
            <ExpenseAccount
              style={{ margin: "0" }}
              workId={row.id}
            ></ExpenseAccount>
          );
        },
      });
    },
  },
};
</script>
<style scoped></style>
